/**
 * @file index.tsx
 *
 * @fileoverview Shows a video gallery for the organization.
 */

import React, { useContext } from 'react';

import { OrganizationProfile } from '~/jobiqo/types/types';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationVideoGalleryWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/VideoGallery/Empty';
import { OrganizationVideoGalleryWidgetView } from '~/jobiqo/components/Organization/Widgets/VideoGallery/View';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
export const KEY = 'videos';

export interface OrganizationVideoGalleryWidgetProps {
  organization: OrganizationProfile;
}

export const OrganizationVideoGalleryWidget = ({
  organization,
}: OrganizationVideoGalleryWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (!organization.videos || organization.videos?.length === 0) {
    return userContext.user && organization.canEdit ? (
      <OrganizationVideoGalleryWidgetEmpty
        organization={organization}
        boxId={KEY}
      />
    ) : null;
  } else {
    return (
      <OrganizationVideoGalleryWidgetView
        organization={organization}
        boxId={KEY}
      />
    );
  }
};
export default OrganizationVideoGalleryWidget;
